import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { getdelivererReq, rmdelivererReq, adddelivererReq, upddelivererReq, chDlvPassReq, getDelivTypesReq, ringToggleReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBellSlash, faEdit, faLock, faPlus, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';
import SelectIDInput from '../components/selectIdInput';
import { connect } from 'react-redux';

class Deliverers extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: '',
			phone: '',
			password: '',
			type: '',
			deliverers: null,
			types: null,
			seller: {},
			sid: this.props.match?.params?.id || '',
			errors: { name: '', phone: '', password: '' },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
			ch: false,
			id: '',
		};
	}

	componentDidMount() {
		this.getDeliverers();
		this.getPreReqs();
	}

	getPreReqs = async () => {
		try {
			const types = (await getDelivTypesReq()).data;
			this.setState({
				types
			});
		} catch(err) {
			alertError("Could not fetch required data");
		}
	}

	getDeliverers = () => {
		this.setState({fetchLoading: true});
		getdelivererReq({seller: this.props.match?.params?.id})
		.then( (res) => {
			const { seller, deliverers } = res.data;
			this.setState({deliverers, seller, form: false, ch: false});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch deliverers");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	rmDeliverer = (id, index) => {
		this.setState({deleteLoading: true});
		rmdelivererReq({id})
		.then( (res) => {
			const { deliverers } = this.state;
			deliverers.splice(index, 1);
			this.setState({deliverers});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not remove deliverer");
		}).finally( () => {
			this.setState({deleteLoading: false});
		});
	}
	
	handleChange = ({ target: { name, value } }) => {
		if(name === 'phone') {
			this.setState({[name]: ((parseInt(value) || '').toString()).slice(0, 10) || ''});
		} else {
			this.setState({[name]: value});
		}
	}

	validate = () => {
		const { id, name, phone, password } = this.state;
		let errors = { name: '', phone: '', password: '' }, isValid = true;

		if(!name) {
			errors.name = "Enter name to continue";
			isValid = false;
		}
		if(!phone) {
			errors.phone = "Enter phone to continue";
			isValid = false;
		}
		if(!id && !password) {
			errors.password = "Enter password to continue";
			isValid = false;
		}

		this.setState({errors});
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { id, name, phone, password, type, sid:seller } = this.state;
		if(this.validate()) {
			if(id) {
				this.setState({loading: true});
				upddelivererReq({id, name, phone, type: type || null, seller})
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("Deliverer updated");
					this.getDeliverers();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			} else {
				this.setState({loading: true});
				adddelivererReq({name, phone, password, type: type || null, seller})
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("Deliverer added");
					this.getDeliverers();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			}
		}
	}

	navigateAdd = () => {
		this.setState({ id: '', name: '', phone: '', type: '', password: '', errors: {name: '', phone: '', password: ''}, loading: false, form: true });
	}

	navigateEdit = (id, name, phone, /* password, */ type) => {
		this.setState({ id, name, phone, /* password, */ type, errors: {name: '', phone: '', password: ''}, loading: false, form: true });
	}

	navigateCh = (id, name) => {
		this.setState({ id, name, password: '', errors: {name: '', phone: '', password: ''}, ch: true, loading: false});
	}

	validate2 = () => {
		const { /* id, name, phone, */ password, /* region */ } = this.state;
		let errors = { name: '', phone: '', password: '' }, isValid = true;

		if(!password) {
			errors.password = "Enter password to continue";
			isValid = false;
		}
		
		this.setState({errors});
		return isValid;
	}

	submitCh = (e) => {
		e.preventDefault();
		const { id, password } = this.state;
		if(this.validate2()) {
			this.setState({loading: true});
			chDlvPassReq({id, password})
			.then( (res) => {
				this.setState({loading: false});
				alertSuccess("Password changed");
				this.getDeliverers();
			}).catch( (err) => {
				this.setState({loading: false});
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
		}
	}

	toggRing = (deliverer) => {
		ringToggleReq({ deliverer })
		.then( (res) => {
			alertSuccess(res.data.msg || "Deliverer updated");
			this.getDeliverers();
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not update deliverer");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	render() {
		const { id, name, phone, type, types, password, ch, deliverers, deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { handleChange, handleSubmit, navigateAdd, navigateEdit, navigateCh, submitCh, rmDeliverer, toggRing } = this;
		return (
			ch ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>Change Deliverer Password</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={submitCh}>
									<Form.Group>
										<TextInput onChange={handleChange} value={password} error={errors.password} name="password" label="Password" type="password" />
									</Form.Group>

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			: form ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>{id ? 'Update ' : 'Add '} Deliverer</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group>
										<TextInput onChange={handleChange} value={name} error={errors.name} name="name" label="Name" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={phone} error={errors.phone} name="phone" label="Phone Number" />
									</Form.Group>

									<Form.Group>
										<SelectIDInput options={types} onChange={handleChange} value={type} name="type" label="Deliverer Type" />
									</Form.Group>

									{id ?
										<></>
									:
										<Form.Group>
											<TextInput onChange={handleChange} value={password} error={errors.password} name="password" label="Password" type="password" />
										</Form.Group>
									}

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			:
				<Row style={{marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%'}}>
					<Col md={12} style={{justifyContent: 'flex-end', display: 'flex', marginTop: '10px', marginBottom: '15px'}}>
						<Button variant="success" onClick={navigateAdd} size="md">
							<FontAwesomeIcon icon={faPlus} /> Add Deliverer
						</Button>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(deliverers) ?
						deliverers.length > 0 ?
							<div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>Name</th>
											<th>Phone</th>
											<th>Type</th>
											<th className="th1">Action</th>
										</tr>
									</thead>
									<tbody>
										{deliverers.map(({ id, name, phone, type, ringing }, i) =>
											<tr key={i}>
												<td>{name}</td>
												<td>{phone}</td>
												<td>{type?.name}</td>
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														{ringing ?
															<OverlayTrigger overlay={<Tooltip>Disable Ringer</Tooltip>} delay={{ show: 150, hide: 150 }} >
																<FontAwesomeIcon icon={faBellSlash} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { toggRing(id) }} />
															</OverlayTrigger>
														:
															<OverlayTrigger overlay={<Tooltip>Enable Ringer</Tooltip>} delay={{ show: 150, hide: 150 }} >
																<FontAwesomeIcon icon={faBell} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { toggRing(id) }} />
															</OverlayTrigger>
														}
														<OverlayTrigger overlay={<Tooltip>Edit</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faEdit} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateEdit(id, name, phone, type?.id) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Change Password</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faLock} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateCh(id, name) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" onClick={(e) => { rmDeliverer(id, i) }} />
														</OverlayTrigger>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						:
							<p style={{position: 'fixed', marginLeft: '34%', marginTop: '20%'}}>No deliverers found.</p>
					:
						<></>
					}
				</Row>
		);
	}
}

const mapStateToProps = (state) => ({
	userid: state.session.userid
});

export default connect(mapStateToProps)(Deliverers);